import Vue from "vue";
import App from "./App.vue";
import router from "@/router/frontend/index";
import store from "./stores";
import VueMeta from "vue-meta";

// custom config
import { CONFIG as webConfig } from "./config.js";

import Notify from "@/assets/plugins/vue-notifikation/notification";
import CathayAxios from "@/assets/plugins/cathay.Axios/cathayAxios";
import GoTop from "@/assets/plugins/cathay.page/goTop.js";

// js
import Privacy from "@/assets/plugins/cathay.privacy/privacy.js";

Vue.config.productionTip = false;

Vue.prototype.$conf = webConfig;
Vue.prototype.$conf.INIT();
Vue.prototype.$conf.SHOW_RTNMESSAGE = false;
Vue.prototype.$publicPath = process.env.BASE_URL;

Vue.use(CathayAxios, { conf: Vue.prototype.$conf });
Vue.use(Notify);
Vue.use(GoTop);
Vue.use(Privacy);
Vue.use(store);
Vue.use(VueMeta);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
